import { FIELDS_TO_TRANSFORM } from "services/sosInventoryService/salesOrder/schema";
import { salesTransactionBeforeSave } from "services/sosInventoryService/salesTransaction/beforeSave";
import {
  nonUtcDateTimeHandling,
  normalizeDateFields,
} from "services/utility/beforeSave";

import { OBJECT_TYPES } from "appConstants";

export function beforeSave(record) {
  let newRecord = salesTransactionBeforeSave(
    OBJECT_TYPES.SALES_ORDER.fullString,
    record
  );

  newRecord = nonUtcDateTimeHandling(newRecord);
  newRecord = normalizeDateFields(newRecord, FIELDS_TO_TRANSFORM.DATE_FIELDS);

  return newRecord;
}
